import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  customers: [],
};

const getters = {
  allCustomers: (state) => state.customers,
};

const actions = {
  async fetchCustomers({ commit }, params = {}) {
    try {
      commit("resetCustomers");
      const response = await axios.get("/customer", { params: prm(params) });
      commit("setCustomers", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch customers:", error);
    }
  },
  async createCustomer({ commit }, customer) {
    try {
      const response = await axios.post("/customer", customer);
      commit("addCustomer", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create customer:", error);
      throw error;
    }
  },
  async fetchCustomerById(_, id) {
    try {
      const response = await axios.get(`/customer/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch customer:", error);
      throw error;
    }
  },
  async updateCustomer({ commit }, customer) {
    try {
      const response = await axios.put(`/customer/${customer.id}`, customer);
      commit("updateCustomer", response.data);
    } catch (error) {
      console.error("Failed to update customer:", error);
      throw error;
    }
  },
  async deleteCustomerById({ commit }, id) {
    try {
      const response = await axios.delete(`/customer/${id}`);
      commit("removeCustomer", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete customer:", error);
      throw error;
    }
  },
};

const mutations = {
  setCustomers(state, customers) {
    state.customers = customers.data; // Ensure this matches your API's response structure
  },
  addCustomer(state, customer) {
    state.customers.push(customer);
  },
  updateCustomer(state, updatedCustomer) {
    const index = state.customers.findIndex(
      (customer) => customer.id === updatedCustomer.id
    );
    if (index !== -1) {
      state.customers.splice(index, 1, updatedCustomer);
    }
  },
  removeCustomer(state, id) {
    state.customers = state.customers.filter(
      (customer) => customer.id !== id
    );
  },
  resetCustomers(state) {
    state.customers = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
